<script setup lang="ts">
import AppHeader from '@/components/AppHeader.vue'
</script>

<template>
  <div class="flex min-h-screen flex-col bg-[radial-gradient(circle_at_top_left,#d1fae5,transparent_34rem),linear-gradient(180deg,#f8fafc,#ecfdf5)]">
    <AppHeader />
    <main class="flex-1">
      <slot />
    </main>
    <footer class="border-t border-white/70 bg-white/75 px-4 py-5 text-center text-sm text-slate-500 backdrop-blur">
      <p>aifantasy.football · private beta draft helper foundation</p>
    </footer>
  </div>
</template>
